/**
 * Detection of browser network-failure messages from failed fetch/XHR
 * calls. Shared by the Sentry init sampling filter (main.js) and by
 * fire-and-forget request error handling that must not report expected
 * connectivity failures.
 *
 * Each engine produces its own TypeError message for a request that
 * fails at the network layer (offline, DNS failure, connection reset,
 * blocked by an extension):
 * - Chromium: "Failed to fetch"
 * - WebKit:   "Load failed"
 * - Gecko:    "NetworkError when attempting to fetch resource."
 *
 * Prefix matching (not equality) also covers decorated variants such
 * as "Load failed (ipstatic.net)".
 */
const NETWORK_ERROR_MESSAGE_PREFIXES = [
    'Failed to fetch',
    'Load failed',
    'NetworkError when attempting to fetch resource',
];

/**
 * @param {unknown} message Error message (or Sentry exception value)
 * @returns {boolean} true when the message is a network-layer failure
 */
export function isNetworkErrorMessage(message) {
    const text = typeof message === 'string' ? message : '';
    return NETWORK_ERROR_MESSAGE_PREFIXES.some((prefix) => text.startsWith(prefix));
}
